const PlayCircled = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m14.775 12.51-3.837 2.47a.54.54 0 0 1-.618.037.58.58 0 0 1-.32-.546V9.53a.58.58 0 0 1 .32-.546.54.54 0 0 1 .618.036l3.837 2.472a.58.58 0 0 1 .292.511.57.57 0 0 1-.292.507"
    />
  </>
)
export default PlayCircled
